












































































import { BarcodeField } from "@/components/form/InputFields";

import Vue from "vue";
import {
  Asortyment,
  asortymentResource,
} from "@megarax/client/src/resources/plm/Asortyment";
import { opakowanieResource } from "@megarax/client/src/resources/plm/Opakowanie";
import { languageResource } from "@megarax/client/src/resources/plm/Language";
import { wyrobResource } from "@megarax/client/src/resources/plm/Wyrob";
import DefaultRevisionForm from "@/components/DefaultRevisionForm.vue";
import { createComponent } from "@vue/composition-api";
import { formValidator } from "@/shared/formValidator";
import { required } from "@/shared/validationRules";

const validationRules = {
  name: required,
  wyrob: required,
};

export default createComponent({
  components: {
    BarcodeField,
    DefaultRevisionForm,
  },
  props: {
    value: {
      required: true,
      type: Asortyment,
    },
  },
  setup(props, ctx) {
    return {
      validationRules,
      ...formValidator(),
      resource: asortymentResource,
      wyrobResource,
      opakowanieResource,
      languageResource,
    };
  },
});
